<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="$t('project.globalAdvancement')"
    />

    <div class="ma-8">
      <v-simple-table class="elevation-1 rai-steps-table">
        <template v-slot:default>
          <tbody>
            <tr
              v-for="step in steps"
              :key="step.name"
              :class="{'rai-disabled-row': step.disabled}"
            >
              <td class="font-weight-black" @click="goToStep(step)">{{ $t(step.name) }}</td>
              <td>
                <v-btn
                  v-if="!step.disabled"
                  class="float-right"
                  icon
                  color="ternary"
                  @click="goToStep(step)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </td>
              <td style="width: 30px;">
                <v-btn
                  v-if="!loading"
                  @click="toggleStep(step)"
                  class="float-right"
                  icon
                >
                  <v-icon
                    :color="step.completed ? 'green' : 'grey'"
                  >
                    mdi-{{step.completed ? 'check' : 'close'}}
                  </v-icon>
                </v-btn>
                <v-progress-circular
                  v-else
                  indeterminate
                  width="2"
                  color="light-gray"
                ></v-progress-circular>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import projectService from '@/services/projects.js';

import projectPageMixin from '@/mixins/project-page-mixin.js';

export default {
  name: 'ProjectSteps',

  components: { PageContentToolbar },

  mixins: [ projectPageMixin ],

  data () {
    return {
      loading: false,
      projectId: '',
      steps: [
        { name: 'option.identify', completed: false, disabled: false, route: '<projectId>/identifyOptions' },
        { name: 'scenario.addMinimalScenarii', completed: false, disabled: false, route: '<projectId>/addScenarii' },
        { name: 'scenario.addOptionsToExistingScenario', completed: false, disabled: false, route: '<projectId>/addOptionsToScenario/noId' },
        { name: 'option.identifyContradictoryOptions', completed: false, disabled: false, route: '<projectId>/identifyContradictoryOptions' },
        { name: 'scenario.identifyIncompatibleScenarii', completed: false, disabled: false, route: '<projectId>/incompatibleScenarii' },
        { name: 'project.knowledgeRepresentation', completed: false, disabled: false, route: '<projectId>/scenariiList' },
        { name: 'project.resolveConflictsWithinMinimumScenarios', completed: false, disabled: false, route: '<projectId>/conflictResolution' },
        { name: 'project.resolveConflictsInCombinationsOfMinimumScenarios', completed: false, disabled: false, route: '<projectId>/resolveConflictsInCombinationsOfMinimumScenarios' },
      ],
    };
  },

  methods: {
    goToStep (step) {
      this.$router.push({ path: step.route.replace('<projectId>', this.$route.params.id) });
    },

    toggleStep (step) {
      step.completed = !step.completed;
      projectService.saveSteps(this.projectId, this.projectSteps).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      });
    },
  },

  computed: {
      projectSteps(){
        return  {
          identifyOptions: this.steps[0].completed,
          addMinimalScenariosForEachOption: this.steps[1].completed,
          addMoreOptionToAnExistingScenario: this.steps[2].completed,
          identifyConflictingOptions: this.steps[3].completed,
          identifyIncompatibleScenarios: this.steps[4].completed,
          knowledgeRepresentation: this.steps[5].completed,
          resolveConflictsWithinMinimalScenarios: this.steps[6].completed,
          resolveConflictsInCombinationsOfMinimalScenarios: this.steps[7].completed,
          resolveConflictsInCombinationsOfMinimalScenariosForBelieves: this.steps[8].completed
        };
      },
  },

  created() {
    this.loading = true;
    this.projectId = this.$route.params.id;
    projectService.getSteps(this.projectId).then((res) => {
      this.steps[0].completed = res.data.identifyOptions;
      this.steps[1].completed = res.data.addMinimalScenariosForEachOption;
      this.steps[2].completed = res.data.addMoreOptionToAnExistingScenario;
      this.steps[3].completed = res.data.identifyConflictingOptions;
      this.steps[4].completed = res.data.identifyIncompatibleScenarios;
      this.steps[5].completed = res.data.knowledgeRepresentation;
      this.steps[6].completed = res.data.resolveConflictsWithinMinimalScenarios;
      this.steps[7].completed = res.data.resolveConflictsInCombinationsOfMinimalScenarios;
    })
    .catch(err => {
      this.$emit('raison-event', { type: 'error', messages: [err] });
    })
    .finally(() => {
      this.loading = false;
    })
  }
};
</script>

<style>
.rai-disabled-row {
  color: grey;
  background-color: #efefef;
  cursor: not-allowed;
}
.rai-steps-table.v-data-table tr {
  cursor: pointer;
}
</style>